import type { FunctionComponent } from 'react';
import { paletteHelper, Text, typographyHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { DialogModal } from '../../../../../app-kit/components/DialogModal/DialogModal';

interface PropertyValuationDisclaimerProps {
  opened: boolean;
  onClose: () => void;
}

const BodyText = styled(Text)`
  ${typographyHelper('body01')};
  color: ${paletteHelper('textSecondary')};
`;

export const PropertyValuationDisclaimer: FunctionComponent<PropertyValuationDisclaimerProps> = ({
  opened,
  onClose,
}) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      title="What is 'estimated value'?"
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
    >
      <BodyText>
        &apos;Estimated value&apos; is a computer generated price calculated and supplied monthly by
        PropTrack using automated statistical models based on available local property data,
        including the type of property, recent sales and local price trends.
      </BodyText>
      <BodyText>
        It is not a price prediction and is only used as an indication of the potential value of a
        property. The &apos;estimated value&apos; is current at the time of publication and should
        not be relied upon as an accurate representation of the market value of a property.
      </BodyText>
      <BodyText>
        realestate.com.au Pty Ltd makes no warranty as to the accuracy or reliability of the
        information contained in the &apos;estimated value&apos; and realestate.com.au and its
        related entities, directors, officers and agents disclaim all liability and responsibility
        for any direct or indirect loss or damage which may be suffered by the recipient through
        relying on anything contained in or omitted from an &apos;estimated value&apos;.
      </BodyText>
      <BodyText>
        We encourage homeowners and property seekers to supplement this information with an
        appraisal from a local real estate agent.
      </BodyText>
    </DialogModal>
  );
};
